import { connect } from 'react-redux'
import * as actions from '../../../actions'
import LeftMenuBar from '../components/LeftMenuBar'

const mapStateToProps = (state) => {
  const { open } = state.leftMenuBar
  const { language } = state.user
  return ({
    open,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleOpen: () => dispatch(actions.leftMenuBar.open()),
    handleClose: () => dispatch(actions.leftMenuBar.close()),
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LeftMenuBar)


// WEBPACK FOOTER //
// ./src/Parts/MenuAppBar/containers/LeftMenuBar.js